import { State, AUTH_FEATURE_KEY } from './auth.reducers';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const getAuthState = createFeatureSelector<State>(AUTH_FEATURE_KEY);

export const getIsAuth = createSelector(
  getAuthState,
  state => state.isAuthenticated
);

export const getUser = createSelector(getAuthState, state => state.user);

export const isCheckoutFlow = createSelector(
  getAuthState,
  state =>
    state.redirectUrl &&
    (state.redirectUrl.indexOf('/checkout/') === 0 ||
      state.redirectUrl.indexOf('/checkouts/') === 0)
);

export const getRedirectUrl = createSelector(
  getAuthState,
  state => state.redirectUrl
);

export const isLoading = createSelector(
  getAuthState,
  state => state.showLoader
);

export const errorMessage = createSelector(
  getAuthState,
  state => state.errorMessage
);

export const getForgotPasswordSuccess = createSelector(
  getAuthState,
  state => state.forgotPasswordSuccess
);
